/**
 * ImpersonationBanner — banner fisso in cima alla pagina durante l'impersonazione.
 * Non rimovibile dall'utente. Mostra tenant, operatore e pulsante "Esci".
 */
import { useImpersonation } from '../../contexts/ImpersonationContext'

export function ImpersonationBanner() {
  const { impersonation, endImpersonation } = useImpersonation()

  if (!impersonation) return null

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: '#b45309',
        color: '#fff',
        fontSize: 13,
        fontWeight: 500,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '6px 20px',
        gap: 12,
      }}
    >
      <span>
        ⚠️ <strong>MODALITÀ SUPPORTO</strong> — Stai visualizzando:{' '}
        <strong>{impersonation.tenant_name}</strong>
        {' | '}Operatore: {impersonation.impersonator_email}
        {impersonation.is_readonly && (
          <span
            style={{
              marginLeft: 10,
              background: 'rgba(0,0,0,0.25)',
              borderRadius: 4,
              padding: '1px 7px',
              fontSize: 11,
            }}
          >
            READ-ONLY
          </span>
        )}
      </span>
      <button
        onClick={endImpersonation}
        style={{
          background: 'rgba(0,0,0,0.25)',
          border: 'none',
          color: '#fff',
          borderRadius: 6,
          padding: '3px 12px',
          cursor: 'pointer',
          fontSize: 12,
          fontWeight: 600,
          whiteSpace: 'nowrap',
        }}
      >
        Esci
      </button>
    </div>
  )
}
